export function getUrlParam(name) {
  const search = window.location.hash.split('?');
  if (!search[1]) {
    return null;
  }
  const params = search[1].split('&');
  let result = null;
  try {
    params.forEach(val => {
      const arr = val.split('=');
      if (name === arr[0]) {
        result = unescape(arr[1]);
        throw new Error('exist');
      }
    });
  } catch (error) {
    // do nothing
  }
  return result;
}

export function httpsReplace(str) {
  if (!str.includes('https')) {
    const url = str.replace(/^http/, 'https');
    return url;
  }
  return str;
}

export function replaceLogin(redirect = undefined) {
  const currentUrl = encodeURIComponent(redirect || location.href);
  const channelCode = getUrlParam('channelCode');
  if (!redirect) {
    window.location.replace(
      `${process.env.VUE_APP_STATICE}/collection/login2/dist/index.html#/login?channelCode=${channelCode}&redirect=${currentUrl}`
    );
  } else {
    window.location.href = `${process.env.VUE_APP_STATICE}/collection/login2/dist/index.html#/login?channelCode=${channelCode}&redirect=${currentUrl}`;
  }
}

export const submitOnce = (function() {
  let isRunning = false;
  return function(callback, context, time) {
    if (!isRunning) {
      isRunning = true;
      let temp = callback.call(context);
      if (temp && temp.then && temp.then.constructor === Function) {
        temp.then(() => (isRunning = false)).catch(() => (isRunning = false));
      } else {
        setTimeout(function() {
          isRunning = false;
        }, time || 1000);
      }
      return temp;
    }
  };
})();
